import cx from 'classnames'
import { type MutableRefObject } from 'react'

import { type UrlParameter } from '@lib/hooks'
import { type Filter, getProductKey } from '@lib/product'
import { type CollectionProduct } from '@lib/product-collection'

import ProductCard from '@blocks/shop/product-card'

interface CollectionProductsProps {
  productCardRef: MutableRefObject<(HTMLDivElement | null)[]>
  productCount: number
  products: CollectionProduct[]
  filters: Filter[]
  parameters: UrlParameter[]
}

const CollectionProducts = ({
  productCardRef,
  productCount,
  products,
  filters,
  parameters,
}: CollectionProductsProps) => {
  return (
    <div
      className={cx('grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4', {
        'grid-cols-1': productCount === 0,
      })}
    >
      {products.map((product, index) => {
        const productKey = getProductKey(product)
        const activeParameterKey = parameters
          .filter((parameter) => parameter.name !== 'page')
          .map((parameter) => parameter.value)
          .filter(Boolean)
          .join('-')

        return (
          <ProductCard
            key={`${index}-${productKey}-${activeParameterKey}`}
            ref={(node) => {
              productCardRef.current[index] = node
            }}
            product={product}
            preferredOption={product.preferredOption}
            filters={filters}
            showThumbnails
            showOption
            showPrice
          />
        )
      })}
    </div>
  )
}

export default CollectionProducts
